/**
 * Morph (FLIP) entre superfícies do chat, no estilo do composer flutuante do
 * Avocado: a nova superfície nasce do retângulo de quem a abriu.
 *
 * `rememberOrigin` grava a origem e `morphIn` a consome. A origem vale por pouco
 * tempo e só para o alvo nomeado, para uma navegação qualquer não herdar animação.
 */

const MORPH_MS = 520;
const CONTENT_DELAY_MS = 260;
const ORIGIN_TTL_MS = 1500;
const EASE_LAND = 'cubic-bezier(0.2, 1.12, 0.32, 1)';
const EASE_OUT = 'cubic-bezier(0.4, 0, 0.2, 1)';
let origin = null;
export const reducedMotion = () => {
  var _window$matchMedia$ma, _window$matchMedia, _window;
  return (_window$matchMedia$ma = (_window$matchMedia = (_window = window).matchMedia) == null ? void 0 : _window$matchMedia.call(_window, '(prefers-reduced-motion: reduce)').matches) != null ? _window$matchMedia$ma : false;
};

/** Grava o elemento que abre `target` como origem; elemento sem caixa não grava nada. */
export function rememberOrigin(el, target) {
  if (!(el instanceof HTMLElement)) return;
  const rect = el.getBoundingClientRect();
  if (rect.width === 0 || rect.height === 0) return;
  const cs = getComputedStyle(el);
  origin = {
    target,
    rect,
    radius: cs.borderTopLeftRadius,
    bg: cs.backgroundColor,
    shadow: cs.boxShadow,
    at: Date.now()
  };
}

/**
 * Leva `el` do retângulo gravado até o lugar dele. Retorna se animou; sem origem
 * recente para o alvo, ou com reduced motion, não faz nada.
 */
export function morphIn(el, target, contentDelay) {
  if (contentDelay === void 0) {
    contentDelay = CONTENT_DELAY_MS;
  }
  const from = origin;
  if (!from || from.target !== target) return false;
  origin = null;
  if (!(el instanceof HTMLElement) || Date.now() - from.at > ORIGIN_TTL_MS) return false;
  if (reducedMotion() || typeof el.animate !== 'function') return false;
  const home = el.getBoundingClientRect();
  if (home.width === 0 || home.height === 0) return false;
  const sx = from.rect.width / home.width;
  const sy = from.rect.height / home.height;
  const radius = parseFloat(from.radius) || 0;
  const own = getComputedStyle(el);
  el.animate([{
    transformOrigin: 'top left',
    transform: "translate(".concat(from.rect.left - home.left, "px, ").concat(from.rect.top - home.top, "px) scale(").concat(sx, ", ").concat(sy, ")"),
    borderRadius: "".concat(radius / sx, "px / ").concat(radius / sy, "px"),
    backgroundColor: from.bg,
    boxShadow: from.shadow
  }, {
    transformOrigin: 'top left',
    transform: 'none',
    borderRadius: own.borderTopLeftRadius,
    backgroundColor: own.backgroundColor,
    boxShadow: own.boxShadow
  }], {
    duration: MORPH_MS,
    easing: EASE_LAND
  });
  cascadeIn(el, contentDelay);
  return true;
}

/** Conteúdo entra em cascata quando a superfície está quase pousando. */
export function cascadeIn(el, delay) {
  if (delay === void 0) {
    delay = CONTENT_DELAY_MS;
  }
  if (reducedMotion() || typeof el.animate !== 'function') return;
  Array.from(el.children).forEach((child, i) => child.animate([{
    opacity: 0,
    transform: 'translateY(6px)'
  }, {
    opacity: 1,
    transform: 'none'
  }], {
    duration: 240,
    delay: delay + i * 40,
    easing: EASE_OUT,
    fill: 'backwards'
  }));
}
flarum.reg.add('ramon-chat', 'forum/utils/morph', { reducedMotion: reducedMotion,rememberOrigin: rememberOrigin,morphIn: morphIn,cascadeIn: cascadeIn, });